/**
 * storage 模块提供 localStorage 的封装
 * @module storage
 */

let proxy = {};

export function getStorage (key) {
  try {
    return localStorage.getItem(key);
  } catch (err) {
    return proxy[key];
  }
}

export function setStorage (key, val) {
  try {
    localStorage.setItem(key, val);
  } catch (err) {
    proxy[key] = val;
  }
}

export function removeStorage (key) {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    delete proxy[key];
  }
}
